import {fromJS} from "immutable";
import * as ActionTypes from '../actions/index';
import {createReducer} from "./index";

const defaultState = fromJS({
  fetching: false,
  brands: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  orderBy: 0,
  order: 'desc',
  errorMessage: undefined,
  tempImage: undefined,
  changedBrand: undefined,
});

function getBrands(state, action) {
  return state.set('fetching', true);
}

function getBrandsSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('brands', fromJS(action.payload.body))
}

function getBrandsFailed(state, action) {
  return state.set('fetching', false);
}

function countBrands(state, action) {
  return state; // TODO: Why????
}

function countBrandsSuccess(state, action) {
  return state
    .set('total', action.payload.body.count)
}

function countBrandsFailed(state, action) {
  return state;
}

function storeTemporaryBrandImage(state, action) {
  return state.set('tempImage', action.payload)
}

function createBrand(state, action) {
  return state;
}

function createBrandSuccess(state, action) {
  return state
    .set('tempImage', undefined)
}

function createBrandFailed(state, action) {
  return state;
}

function clearBrandForm(state, action) {
  return state
    .set('tempImage', undefined)
}

function changeBrandPreferences(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function changeBrandsOrder(state, action) {
  return state
    .set('order', action.payload.order)
    .set('orderBy', action.payload.orderBy)
}

function deleteBrandFailed(state, action) {
  let errorMessage = null;
  try {
    errorMessage = action.payload.response.body.error.message
  } catch (e) {
    errorMessage = 'Failed to delete the brand'
  }

  return state
    .set('errorMessage', errorMessage)
}

function clearBrandDeleteErrorMessage(state, action) {
  return state.set('errorMessage', undefined);
}

function clearTempUploadedProductBrand(state, action) {
  return state.set('tempImage', undefined);
}

function copyBrandForEdit(state, action) {
  const brandId = action.payload;
  const brand = state
    .get('brands').valueSeq().toArray()
    .filter(brandImmutable =>
      String(brandImmutable.get('id')) === String(brandId))[0];
  return state.set('changedBrand', brand );
}

function editLabelField(state, action) {
  return state
    .setIn(['changedBrand', action.payload.field], action.payload.value);
}

export const brands = createReducer(defaultState, {
  [ActionTypes.GET_BRANDS]: getBrands,
  [ActionTypes.GET_BRANDS_SUCCESS]: getBrandsSuccess,
  [ActionTypes.GET_BRANDS_FAILED]: getBrandsFailed,
  [ActionTypes.COUNT_BRANDS]: countBrands,
  [ActionTypes.COUNT_BRANDS_SUCCESS]: countBrandsSuccess,
  [ActionTypes.COUNT_BRANDS_FAILED]: countBrandsFailed,
  [ActionTypes.CREATE_BRAND]: createBrand,
  [ActionTypes.CREATE_BRAND_SUCCESS]: createBrandSuccess,
  [ActionTypes.CREATE_BRAND_FAILED]: createBrandFailed,
  [ActionTypes.STORE_TEMPORARY_BRAND_IMAGE]: storeTemporaryBrandImage,
  [ActionTypes.CHANGE_BRANDS_PREFERENCES]: changeBrandPreferences,
  [ActionTypes.CHANGE_BRANDS_ORDER]: changeBrandsOrder,
  [ActionTypes.CLEAR_BRAND_FORM]: clearBrandForm,
  [ActionTypes.DELETE_BRAND_FAILED]: deleteBrandFailed,
  [ActionTypes.CLEAR_BRAND_DELETE_ERROR_MESSAGE]: clearBrandDeleteErrorMessage,
  [ActionTypes.CLEAR_TEMP_UPLOADED_PRODUCT_BRAND]: clearTempUploadedProductBrand,
  [ActionTypes.EDIT_BRAND_FIELD]: editLabelField,
  [ActionTypes.COPY_BRAND_FOR_EDIT]: copyBrandForEdit,
});



// WEBPACK FOOTER //
// ./src/reducers/brands.js